<ap-section-header>
  <ap-section-header-grid
    [iconId]="'ap-administration-icon'"
    [caption]="'Admin_Pages__Protocol'"
    [filterPlaceholder]="'Global_Filter'"
    [filterTooltip]="'Admin_Pages__Protocol'"
    [createText]="'Global__New'"
    (search)="searchIn($event)"
    [canCreate]="false">
  </ap-section-header-grid>
</ap-section-header>
<div class="ap-tabstrip-small">
  <kendo-tabstrip (tabSelect)="selectTab($event)" id="traceLogTabStrip">
    <kendo-tabstrip-tab [selected]="true">
      <ng-template kendoTabTitle>
        <ap-responsive-text key="actions" class="ap-tabstrip-header"></ap-responsive-text>
      </ng-template>
      <ng-template kendoTabContent>
        <ap-trace-log-actions></ap-trace-log-actions>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab>
      <ng-template kendoTabTitle>
        <ap-responsive-text key="client" class="ap-tabstrip-header"></ap-responsive-text>
      </ng-template>
      <ng-template kendoTabContent>
        <ap-trace-log-client></ap-trace-log-client>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</div>
